import { schema } from 'normalizr'

import Booking from '@/models/booking'
import Customer from '@/models/customer'

import customer from './customer'

export const bookingSchema = new schema.Entity('bookings', {
  customer,
})

export interface BookingsResponse {
  entities: {
    bookings: { [id: number]: Booking }
    customers: { [id: number]: Customer }
  }
  result: string | string[]
}

export default bookingSchema

export const bookingsSchema = [bookingSchema]
